<template>
  <v-container>
    <v-row>
      <v-col>
        <p>Возвращает радар за указанный срок в формате geoJson</p>

        <div class="text-subtitle-1">Заголовки запроса</div>
        <v-simple-table>
          <thead>
            <tr>
              <td>
                <b>Заголовок</b>
              </td>
              <td>
                <b>Описание</b>
              </td>
              <td>
                <b>Пример значения</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Authorization</td>
              <td>JWT токен доступа</td>
              <td>Bearer eyJhbGciOiJSUzI1NiIsImtp...</td>
            </tr>
            <tr>
              <td>Accept-Encoding</td>
              <td>
                Вы можете указать параметр gzip для сжатия ответа. Настоятельно рекомендуем использовать этот заголовок!
                Например, если без сжатия, ответ занимает 4 мегабайта, то с gzip сжатием он будет занимать около 150 килобайт.
              </td>
              <td>gzip</td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-1">Типы запросов</div>

        <v-simple-table>
          <thead>
            <tr>
              <td>
                <b>Запрос</b>
              </td>
              <td>
                <b>Описание</b>
              </td>
              <td>
                <b>Пример</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Параметры</td>
              <td>
                {territory} - Территория, например MR;
                <br />
                {parameter} - Название параметра
                <br />
                {validtimes} - Сроки
              </td>
              <td>
                <code>curl -H 'Authorization: Bearer eyJhbGciOiJSUzI1NiIsImtp...' '{{ $settings.VUE_APP_GATEWAY_SERVICE_ENDPOINT }}/api/1.2/radar/MR/precipitation_intensity/2020-01-01'</code>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-1">Ответ</div>

        <v-simple-table class="table">
          <thead>
            <tr>
              <td>
                <b>Пример ответа</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <json-viewer :value="response" copyable boxed expanded :expand-depth="5" sort></json-viewer>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>


export default {
  
  data: function() {
    return {
      response: {
        status_code: 0,
        message: {
          code: 0,
          msg: "string"
        },
        result: {
          data: [
            {
              type: "string",
              crs: {
                type: "string",
                properties: {
                  code: 0
                },
                coordinate_order: [0]
              },
              properties: {
                type: "string",
                baseTime: "2020-10-30T08:07:45.515Z",
                validTime: "2020-10-30T08:07:45.515Z",
                territory: "string",
                parameter: "string",
                units: "string"
              },
              features: [
                {
                  type: "string",
                  properties: {
                    interval: [0]
                  },
                  geometry: {
                    type: "string",
                    coordinates: [[[[0]]]]
                  }
                }
              ]
            }
          ],
          count: 0
        }
      }
    };
  }
};
</script>